var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M28 8.722C28 6.114 25.874 4 23.253 4h-12.97v5.953h-.974V4h-.562l-.11.002v5.951h-.973V4.125a4.765 4.765 0 0 0-.685.215v5.613h-.974V4.87A4.707 4.707 0 0 0 4 8.722v3.101h7.61A6.138 6.138 0 0 1 15.983 10a6.14 6.14 0 0 1 4.375 1.823H28V8.722H28zM15.984 20.816c2.609 0 4.73-2.111 4.73-4.707A4.687 4.687 0 0 0 19.1 12.57a4.727 4.727 0 0 0-5.067-.748 4.781 4.781 0 0 0-1.164.748 4.687 4.687 0 0 0-1.615 3.538c0 2.596 2.122 4.707 4.73 4.707zM28 12.571h-7.011a6.061 6.061 0 0 1 1.136 3.538c0 3.374-2.75 6.11-6.141 6.11s-6.14-2.736-6.14-6.11c0-1.319.421-2.539 1.136-3.538H4v10.708C4 25.886 6.126 28 8.747 28h14.506C25.875 28 28 25.886 28 23.279V12.57zm-12 7.017a3.488 3.488 0 0 0 3.496-3.48A3.487 3.487 0 0 0 16 12.632a3.487 3.487 0 0 0-3.496 3.478A3.488 3.488 0 0 0 16 19.588zm9.83-12.856v2.61a.76.76 0 0 1-.762.756h-2.565a.76.76 0 0 1-.762-.757v-2.61a.76.76 0 0 1 .762-.757h2.565c.421 0 .762.34.762.758z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b2b28b1b.svg";
export { ForwardRef as ReactComponent };